<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import GroupLimitsRequest from 'Modules/contacard/limits/groupLimits/GroupLimitsRequest';
import GroupNameColumnVue from './components/GroupNameColumn.vue';
import ClientNameColumnVue from './components/ClientNameColumn.vue';
import GroupRazaoSocialColumnVue from './components/GroupRazaoSocialColumn.vue';

export default {
  name: 'GroupLimitsCrudList',
  extends: CrudListVue,
  data: () => ({
    editRoute: 'groupLimits.edit',
    requestClass: GroupLimitsRequest,
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Agrupamento',
        value: 'idProdutoAgrupamento',
        component: GroupNameColumnVue,
      },
      {
        text: 'Cliente',
        value: 'idCliente',
        component: ClientNameColumnVue,
      },
      {
        text: 'Razão social',
        value: 'idCliente',
        component: GroupRazaoSocialColumnVue,
      },
      {
        text: 'Código do cliente',
        value: 'idCliente',
      },
      {
        text: 'Quantidade',
        value: 'quantidade',
      },
      {
        text: 'Tempo em segundos',
        value: 'tempoEmSegundos',
      },
      {
        text: 'Última atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
